module.exports = __webpack_public_path__ + "img/OT526.80f78f5.jpg";